export const customEventTypeAttr = 'data-xmleventtype';
export const customEventFunAttr = 'data-xmleventfun';
